export default class Office {
  constructor(companyId, title, city, address, lat, lon, radius, disabled) {
    this.companyId = companyId
    this.title = title
    this.city = city
    this.address = address
    this.lat = lat
    this.lon = lon
    this.radius = radius
    this.disabled = disabled
  }
}
